import StorageKeys from 'constants/StorageKeys';
import en from 'i18n/en';
import ru from 'i18n/ru';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const acceptableLangs = ['en', 'ru'];

export const getLang = (): string => {
  const storedLang = localStorage.getItem(StorageKeys.lang)?.split('-')[0];
  const lsLang = storedLang && acceptableLangs.includes(storedLang) ? storedLang : null;

  if (!lsLang) {
    const lang = navigator.language;
    if (lang) {
      const langCode = lang.split('-')[0];
      if (acceptableLangs.includes(langCode)) {
        return langCode;
      }
    }

    return 'en';
  } else {
    return lsLang;
  }
};

i18n.use(initReactI18next).init({
  resources: {
    en,
    ru,
  },
  lng: getLang(),
  fallbackLng: 'en',
  supportedLngs: acceptableLangs,
  load: 'languageOnly',
});
